/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';

/**
 * The IntegrationscontentfulContentfulIntegration model module.
 * @module model/IntegrationscontentfulContentfulIntegration
 * @version v0.3
 */
export default class IntegrationscontentfulContentfulIntegration {
  /**
   * Constructs a new <code>IntegrationscontentfulContentfulIntegration</code>.
   * @alias module:model/IntegrationscontentfulContentfulIntegration
   * @class
   * @param publicAccessToken {String} 
   * @param spaceId {String} 
   */
  constructor(publicAccessToken, spaceId) {
    this.publicAccessToken = publicAccessToken;
    this.spaceId = spaceId;
  }

  /**
   * Constructs a <code>IntegrationscontentfulContentfulIntegration</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationscontentfulContentfulIntegration} obj Optional instance to populate.
   * @return {module:model/IntegrationscontentfulContentfulIntegration} The populated <code>IntegrationscontentfulContentfulIntegration</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationscontentfulContentfulIntegration();
      if (data.hasOwnProperty('public_access_token'))
        obj.publicAccessToken = ApiClient.convertToType(data['public_access_token'], 'String');
      if (data.hasOwnProperty('space_id'))
        obj.spaceId = ApiClient.convertToType(data['space_id'], 'String');
      if (data.hasOwnProperty('api_environment'))
        obj.apiEnvironment = ApiClient.convertToType(data['api_environment'], 'String');
      if (data.hasOwnProperty('enabled'))
        obj.enabled = ApiClient.convertToType(data['enabled'], 'Boolean');
    }
    return obj;
  }
}

/**
 * @member {String} publicAccessToken
 */
IntegrationscontentfulContentfulIntegration.prototype.publicAccessToken = undefined;

/**
 * @member {String} spaceId
 */
IntegrationscontentfulContentfulIntegration.prototype.spaceId = undefined;

/**
 * @member {String} apiEnvironment
 * @default 'master'
 */
IntegrationscontentfulContentfulIntegration.prototype.apiEnvironment = 'master';

/**
 * @member {Boolean} enabled
 * @default true
 */
IntegrationscontentfulContentfulIntegration.prototype.enabled = true;

